import {scrollToElementById} from '@/_application/core/utils/scroll-to-element-by-id';
import {ArrowDownIcon} from '@/_application/icons/arrow-down';
import {useState} from 'react';
import cn from 'classnames';
import {useTranslation} from 'next-i18next';
import ExpandDescriptionContent from './expand-description-content';

interface IProps {
    htmlDescription: string;
    id?: string;
}

const DEFAULT_SCROLL_ELEMENT_ID = 'expand-text-scroll';
const DISTANCE_ADJUSTMENT = -140;
const MINIMUM_DESCRIPTION_LENGTH = 190;

function ExpandDescription({htmlDescription, id = DEFAULT_SCROLL_ELEMENT_ID}: Readonly<IProps>) {
    const [isOpen, setIsOpen] = useState(false);
    const {t} = useTranslation('common');

    const handleToggle = () => {
        if (isOpen) {
            setTimeout(() => {
                scrollToElementById(id, DISTANCE_ADJUSTMENT);
            }, 100);
        }
        setIsOpen(prev => !prev);
    };

    if (!htmlDescription) return <></>;

    return (
        <section className="mt-5 bg-white p-5 md:rounded-2xl" id={id}>
            <div
                className={cn('category-description-block relative overflow-hidden', {
                    'h-[180px]': !isOpen && htmlDescription?.length > MINIMUM_DESCRIPTION_LENGTH,
                })}>
                <ExpandDescriptionContent htmlDescription={htmlDescription} isOpen={isOpen} />
            </div>
            <button
                className="mt-2 flex items-center justify-center text-sm text-primary md:transition-colors hover:md:text-KPZ_turquoise"
                aria-label="Hiện/ẩn mô tả sản phẩm"
                onClick={handleToggle}>
                {isOpen ? (
                    <>
                        <p className="font-bold">{t('text-load-summary')}</p>
                        <ArrowDownIcon className="ml-1.5 h-2.5 w-2.5 rotate-180" />
                    </>
                ) : (
                    <>
                        <p className="font-bold">{t('text-load-more')}</p>
                        <ArrowDownIcon className="ml-1.5 h-2.5 w-2.5" />
                    </>
                )}
            </button>
        </section>
    );
}

export default ExpandDescription;
